import {Component, Inject, OnInit, inject, DestroyRef} from '@angular/core';
import {translate} from '@jsverse/transloco';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Constants } from 'src/app/models/constants';
import { FormUtilService } from 'src/app/services/util/form-util.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-approve-dialog',
    templateUrl: './approve-dialog.component.html',
    styleUrls: ['./approve-dialog.component.scss'],
    standalone: false
})
export class ApproveDialogComponent  implements OnInit {

  title: string = translate('DIALOG.CONFIRMATION');
  message: string;
  confirmButtonText: string = translate('DIALOG.CONFIRM');
  approveForm: FormGroup;
  Constants = Constants;
  private destroyRef = inject(DestroyRef);

  constructor(@Inject(MAT_DIALOG_DATA) private data: any, private formBuilder: FormBuilder, public matdialogRef: MatDialogRef<ApproveDialogComponent>) {
    
  }

  ngOnInit(): void {
    this.title = this.data.title || this.title;
    this.message = this.data.message;
    this.confirmButtonText = this.data.confirmButtonText || this.confirmButtonText;
    const formConfig: any = {
      ticketNumber: ['', [Validators.required, Validators.pattern(/^ITSM-[a-zA-Z0-9].{1}|^CEPR-[a-zA-Z0-9].{1}/)]],
      description: ['']
    };
    this.approveForm = this.formBuilder.group(formConfig);
  }

  verifyForm(): void {
    if (!FormUtilService.validateForm(this.approveForm)) {
      return;
    } else {
      const data: any = {
       ticketNumber: this.approveForm.value.ticketNumber,
       description: this.approveForm.value.description
      };
      this.matdialogRef.close(data);
    }
  }
}

